<template>
  <div id="TranshipmentBarChart">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col class="d-flex align-center">
            <h6>{{ title }}</h6>
          </v-col>
          <v-col cols="2">
            <v-select v-model="orderSelected" :items="orderingBy" @change="onOrderChange" label="Ordem"></v-select>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="chart">
        <div style="max-height: 420px; position: relative">
          <div v-if="isLoading" class="loading-screen d-flex justify-center align-center">
            <v-progress-circular indeterminate color="primary" />
          </div>
          <canvas style="max-height: 420px" id="myChart"></canvas>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js';
import { orderBy } from 'lodash';
export default {
  name: 'TranshipmentBarChart',
  props: {
    transhipments: {
      default: () => [],
      type: Array
    },
    isLoading: {
      default: true,
      type: Boolean
    },
    transhipmentCities: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    chartOptions: {},
    chartLabels: [],
    chartData: [],
    charts: null,
    orderingBy: ['Crescente', 'Decrescente', 'Nome'],
    orderSelected: 'Decrescente'
  }),

  computed: {
    title() {
      return this.transhipmentCities ? 'Performance do transbordo por cidade' : 'Performance por ponto de transbordo';
    },

    barChartDataDesc() {
      return orderBy(
        this.transhipments.map(({ city, media, onTime, late, openLate, openOnTime }) => {
          return { city, nested: { media, onTime, late, openLate, openOnTime } };
        }),
        ['nested.media'],
        ['desc']
      );
    },
    barChartDataAsc() {
      return orderBy(
        this.transhipments.map(({ city, media, onTime, late, openLate, openOnTime }) => {
          return { city, nested: { media, onTime, late, openLate, openOnTime } };
        }),
        ['nested.media'],
        ['asc']
      );
    },
    barChartDataByName() {
      return orderBy(
        this.transhipments.map(({ city, media, onTime, late, openLate, openOnTime }) => {
          return { city, nested: { media, onTime, late, openLate, openOnTime } };
        }),
        ['city'],
        ['asc']
      );
    },

    barChartLabels() {
      const labelsObj = {
        Crescente: this.barChartDataAsc,
        Decrescente: this.barChartDataDesc,
        Nome: this.barChartDataByName
      };

      return labelsObj[this.orderSelected].map((transhipment) => transhipment.city);
    }
  },

  watch: {
    isLoading: {
      handler(isLoading) {
        if (!isLoading) {
          if (this.charts === null) {
            this.fillChartData();
            this.renderChart();
          } else {
            this.orderSelected = 'Decrescente';
            this.charts.data.labels = this.barChartLabels;
            this.setDescOrder();
          }
        }
      }
    }
  },

  created() {
    Chart.register(...registerables);
  },

  methods: {
    setAscOrder() {
      this.charts.data.datasets[0].data = this.barChartDataAsc;
      this.charts.update();
    },
    setDescOrder() {
      this.charts.data.datasets[0].data = this.barChartDataDesc;
      this.charts.update();
    },
    setNameOrder() {
      this.charts.data.datasets[0].data = this.barChartDataByName;
      this.charts.update();
    },

    onOrderChange() {
      this.charts.data.labels = this.barChartLabels;
      switch (this.orderSelected) {
        case 'Crescente':
          this.setAscOrder();
          break;
        case 'Decrescente':
          this.setDescOrder();
          break;
        case 'Nome':
          this.setNameOrder();
          break;
        default:
          this.setAscOrder();
      }
    },
    renderChart() {
      const data = {
        datasets: [
          {
            data: this.chartData,

            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(255, 206, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(255, 159, 64, 0.2)'
            ],
            borderColor: [
              'rgba(255, 99, 132, 1)',
              'rgba(54, 162, 235, 1)',
              'rgba(255, 206, 86, 1)',
              'rgba(75, 192, 192, 1)',
              'rgba(153, 102, 255, 1)',
              'rgba(255, 159, 64, 1)'
            ],
            borderWidth: 1
          }
        ]
      };
      const options = this.chartOptions;
      const config = {
        type: 'bar',
        data: data,
        options: options
      };
      this.charts = new Chart(document.getElementById('myChart'), config);
    },

    fillChartData() {
      this.chartLabels = this.barChartLabels;

      this.chartData = this.barChartDataDesc;

      this.chartOptions = {
        parsing: {
          xAxisKey: 'city',
          yAxisKey: 'nested.media'
        },
        scales: {
          y: {
            max: 100,
            min: 0,
            ticks: {
              callback: (label) => `${label}%`,
              stepSize: 20
            }
          },
          x: {
            ticks: {
              font: {
                size: 13
              }
            }
          }
        },
        plugins: {
          tooltip: {
            intersect: false,
            mode: 'index',
            bodyFont: { weight: 'bold' },
            yAlign: 'centered',
            callbacks: {
              label: (context) => {
                const { media } = context.raw.nested;
                return ` Performace: ${media}%`;
              },
              footer: ([context]) => {
                const { onTime, late, openLate, openOnTime } = context.raw.nested;
                const onTimeText = `ENTREGUE NO PRAZO: ${onTime}`;
                const lateText = `ENTREGUE EM ATRASO: ${late}`;
                const openLateText = `ABERTO NO PRAZO: ${openOnTime}`;
                const openOnTimeText = `ABERTO EM ATRASO: ${openLate}`;
                return [onTimeText, lateText, openLateText, openOnTimeText];
              }
            }
          },
          legend: {
            display: false
          }
        }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.loading-screen {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: white;

  border-radius: 5px;
}
</style>
